var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { status } from "@spike/appointment-model";
import { countThunk, fetchAppointmentsThunk, fetchAppointmentsWithStaffIssuesThunk, fetchBookingsThunk, fetchBookingsWithStaffIssuesThunk, fetchPendingAppointmentsThunk, fetchPendingBookingsThunk } from "@spike/bookings-action";
import { convertToYMDWithoutTimeZone } from "@spike/date-utils";
import { SortOrder } from "@spike/booking-model";
import uniqWith from "lodash/uniqWith";
export var Mark;
(function (Mark) {
    Mark["WARNING"] = "warning";
    Mark["ERROR"] = "error";
})(Mark || (Mark = {}));
;
export var staffIssuesView = {
    id: "staff_issues",
    name: "Issues",
    appointmentStatus: [status.CONFIRMED, status.CHECKED_IN, status.IN_PROGRESS, status.READY_FOR_CHECK_OUT, status.WAITING_PAYMENT_CONFIRMATION],
    showAppointments: false,
    showBookings: false,
    showPendingAppointments: false,
    showPendingBookings: false,
    showAppointmentsWithStaffIssues: true,
    showBookingsWithStaffIssues: true,
    mark: Mark.ERROR,
    selectedBackgroundColor: "#E36E74",
    emptyMessage: {
        title: "Oops!",
        description: "There's nothing to see here.",
    }
};
export var pendingView = {
    id: "pending",
    name: "Pending",
    appointmentStatus: [status.CONFIRMED, status.CHECKED_IN, status.IN_PROGRESS, status.READY_FOR_CHECK_OUT, status.PAYMENT, status.WAITING_PAYMENT_CONFIRMATION],
    showAppointments: false,
    showBookings: false,
    showPendingAppointments: true,
    showPendingBookings: true,
    showAppointmentsWithStaffIssues: false,
    showBookingsWithStaffIssues: false,
    mark: Mark.WARNING,
    emptyMessage: {
        title: "Don’t get too comfy.",
        description: "This will fill up soon enough.",
    }
};
export var upcomingView = {
    id: "upcoming",
    name: "Upcoming",
    appointmentStatus: [status.CONFIRMED, status.CHECKED_IN, status.IN_PROGRESS, status.READY_FOR_CHECK_OUT, status.PAYMENT, status.WAITING_PAYMENT_CONFIRMATION],
    showAppointments: true,
    showBookings: true,
    showPendingAppointments: false,
    showPendingBookings: false,
    showAppointmentsWithStaffIssues: false,
    showBookingsWithStaffIssues: false,
    emptyMessage: {
        title: "Don’t get too comfy.",
        description: "This will fill up soon enough.",
    }
};
export var completedView = {
    id: "completed",
    name: "Completed",
    appointmentStatus: [status.COMPLETED],
    showAppointments: true,
    showBookings: false,
    showPendingAppointments: false,
    showPendingBookings: false,
    showBookingsWithStaffIssues: false,
    showAppointmentsWithStaffIssues: false,
    emptyMessage: {
        title: "Almost there.",
        description: "Nothing completed just yet.",
    }
};
export var cancelledView = {
    id: "cancelled",
    name: "Canceled",
    appointmentStatus: [status.CANCELLED, status.NO_SHOW, status.DECLINED],
    showAppointments: true,
    showBookings: false,
    showPendingAppointments: false,
    showPendingBookings: false,
    showAppointmentsWithStaffIssues: false,
    showBookingsWithStaffIssues: false,
    emptyMessage: {
        title: "Almost there.",
        description: "There are currently no cancelations.",
    }
};
export var allView = {
    id: "all",
    name: "All",
    appointmentStatus: [
        status.CONFIRMED,
        status.CHECKED_IN,
        status.IN_PROGRESS,
        status.READY_FOR_CHECK_OUT,
        status.PAYMENT,
        status.WAITING_PAYMENT_CONFIRMATION,
        status.COMPLETED,
        status.CANCELLED,
        status.NO_SHOW,
        status.DECLINED,
    ],
    showAppointments: true,
    showBookings: true,
    showPendingAppointments: false,
    showPendingBookings: false,
    showAppointmentsWithStaffIssues: false,
    showBookingsWithStaffIssues: false,
    emptyMessage: {
        title: "Raise the woof!",
        description: "This will fill up soon enough.",
    }
};
export var views = [staffIssuesView, pendingView, upcomingView, completedView, cancelledView, allView];
export var load = function (apiClientWrapper, dispatch, view, period) {
    var fetchFrom = convertToYMDWithoutTimeZone(period.from);
    var fetchTo = convertToYMDWithoutTimeZone(period.to);
    dispatch(countThunk(apiClientWrapper));
    view.showAppointments && dispatch(fetchAppointmentsThunk(apiClientWrapper, view.appointmentStatus, fetchFrom, fetchTo));
    view.showAppointmentsWithStaffIssues && dispatch(fetchAppointmentsWithStaffIssuesThunk(apiClientWrapper));
    view.showPendingAppointments && dispatch(fetchPendingAppointmentsThunk(apiClientWrapper));
    view.showBookings && dispatch(fetchBookingsThunk(apiClientWrapper, fetchFrom, fetchTo));
    view.showBookingsWithStaffIssues && dispatch(fetchBookingsWithStaffIssuesThunk(apiClientWrapper));
    view.showPendingBookings && dispatch(fetchPendingBookingsThunk(apiClientWrapper));
};
var matchAppointmentByView = function (appointment, view) {
    return ((view.showAppointments ||
        view.showPendingAppointments ||
        view.showAppointmentsWithStaffIssues) &&
        (view.appointmentStatus.length === 0 || view.appointmentStatus.includes(appointment.status.id)));
};
var matchAppointmentByStaff = function (appointment, selectedStaffIds, allStaffSelected) {
    return (allStaffSelected ||
        appointment.services.some(function (service) { var _a; return selectedStaffIds.includes((_a = service.staff) === null || _a === void 0 ? void 0 : _a.id); }));
};
var matchAppointmentByText = function (appointment, searchText) {
    var tokens = searchText.toLocaleLowerCase().split(" ");
    return !tokens.some(function (token) {
        var _a, _b, _c, _d, _e, _f;
        return !((_a = appointment.customer.firstName.toLocaleLowerCase()) === null || _a === void 0 ? void 0 : _a.includes(token)) &&
            !((_b = appointment.customer.lastName.toLocaleLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(token)) &&
            !((_c = appointment.customer.email.toLocaleLowerCase()) === null || _c === void 0 ? void 0 : _c.includes(token)) &&
            !((_d = appointment.customer.phone) === null || _d === void 0 ? void 0 : _d.includes(token)) &&
            !appointment.pet.name.toLocaleLowerCase().includes(token) &&
            !appointment.pet.type.plural.toLocaleLowerCase().includes(token) &&
            !((_e = appointment.pet.breed) === null || _e === void 0 ? void 0 : _e.name.toLocaleLowerCase().includes(token)) &&
            !appointment.services.some(function (service) {
                var _a, _b;
                return service.name.toLocaleLowerCase().includes(token) ||
                    ((_a = service.staff) === null || _a === void 0 ? void 0 : _a.firstName.toLocaleLowerCase().includes(token)) ||
                    ((_b = service.staff) === null || _b === void 0 ? void 0 : _b.lastName.toLocaleLowerCase().includes(token));
            }) &&
            !((_f = appointment.status.name.toLocaleLowerCase()) === null || _f === void 0 ? void 0 : _f.includes(token));
    });
};
var matchAppointment = function (appointment, view, searchText, selectedStaffIds, allStaffSelected) {
    return (matchAppointmentByView(appointment, view) &&
        matchAppointmentByStaff(appointment, selectedStaffIds, allStaffSelected) &&
        (searchText.length === 0 || matchAppointmentByText(appointment, searchText)));
};
var matchBooking = function (wrapper, view, searchText, selectedStaffIds, allStaffSelected) {
    return (wrapper.booking !== undefined &&
        (view.showBookings ||
            view.showPendingBookings ||
            view.showAppointmentsWithStaffIssues) &&
        (allStaffSelected ||
            wrapper.booking.appointments
                .flatMap(function (appointment) { return appointment.services; })
                .map(function (service) { var _a; return (_a = service.staff) === null || _a === void 0 ? void 0 : _a.id; })
                .some(function (staffId) { return selectedStaffIds.includes(staffId); })) &&
        (searchText.length === 0 ||
            wrapper.booking.appointments.some(function (appointment) { return matchAppointmentByText(appointment, searchText); })));
};
var matchWrapper = function (wrapper, view, searchText, selectedStaffIds, allStaffSelected) {
    if (wrapper.appointment) {
        return matchAppointment(wrapper.appointment, view, searchText, selectedStaffIds, allStaffSelected);
    }
    else {
        return matchBooking(wrapper, view, searchText, selectedStaffIds, allStaffSelected);
    }
};
export var getAssignedStaff = function (appointments, bookings) {
    var filteredAppointmentsStaff = appointments.map(function (wrapper) { return wrapper.appointment.services[0].staff; });
    var filteredBookingsStaff = bookings
        .flatMap(function (wrapper) { return wrapper.booking.appointments; })
        .map(function (appointment) { return appointment.services[0].staff; });
    var uniqueAssignedStaff = uniqWith(__spreadArray(__spreadArray([], filteredAppointmentsStaff, true), filteredBookingsStaff, true), function (member, otherMember) { return (member === null || member === void 0 ? void 0 : member.id) === (otherMember === null || otherMember === void 0 ? void 0 : otherMember.id); }).sort(function (staff, otherStaff) {
        if (staff === undefined) {
            return -1;
        }
        else if (otherStaff === undefined) {
            return 1;
        }
        else if ((staff === null || staff === void 0 ? void 0 : staff.firstName) < (otherStaff === null || otherStaff === void 0 ? void 0 : otherStaff.firstName)) {
            return -1;
        }
        else if ((staff === null || staff === void 0 ? void 0 : staff.firstName) > (otherStaff === null || otherStaff === void 0 ? void 0 : otherStaff.firstName)) {
            return 1;
        }
        else {
            return 0;
        }
    });
    return uniqueAssignedStaff;
};
export var filter = function (view, searchText, selectedStaffIds, allStaffSelected, appointments, bookings) {
    var filteredAppointments = view.showAppointments || view.showPendingAppointments || view.showAppointmentsWithStaffIssues
        ? appointments.filter(function (a) { return matchWrapper(a, view, searchText, selectedStaffIds, allStaffSelected); })
        : [];
    var filteredBookings = view.showBookings || view.showPendingAppointments || view.showBookingsWithStaffIssues
        ? bookings.filter(function (b) { var _a; return (_a = b.booking) === null || _a === void 0 ? void 0 : _a.appointments.some(function (a) { return a.status.id === status.BOOKED; }); }).filter(function (b) { return matchWrapper(b, view, searchText, selectedStaffIds, allStaffSelected); })
        : [];
    var filteredBookingsAppointmentsIds = filteredBookings
        .flatMap(function (wrapper) { return wrapper.booking.appointments; })
        .map(function (appointment) { return appointment.id; });
    return __spreadArray(__spreadArray([], filteredAppointments.filter(function (wrapper) { return !filteredBookingsAppointmentsIds.includes(wrapper.appointment.id); }), true), filteredBookings, true);
};
export var sort = function (wrappers, sorting) {
    if (sorting === undefined) {
        return wrappers.sort(function (wrapper, otherWrapper) {
            return wrapper.sort.dateTime.clone().toDate().getTime() - otherWrapper.sort.dateTime.clone().toDate().getTime();
        });
    }
    else {
        return wrappers.sort(function (wrapper, otherWrapper) {
            var value = wrapper.sort[sorting.field];
            var otherValue = otherWrapper.sort[sorting.field];
            if (typeof value === "number") {
                return (value - otherValue) * (sorting.order === SortOrder.ASCENDANT ? 1 : -1);
            }
            else if (typeof value === "string") {
                if (value > otherValue) {
                    return 1 * (sorting.order === SortOrder.ASCENDANT ? 1 : -1);
                }
                else if (value < otherValue) {
                    return -1 * (sorting.order === SortOrder.ASCENDANT ? 1 : -1);
                }
                else {
                    return 0;
                }
            }
            else {
                return ((value.clone().toDate().getTime() - otherValue.clone().toDate().getTime()) *
                    (sorting.order === SortOrder.ASCENDANT ? 1 : -1));
            }
        });
    }
};
